<template>
  <div class="right gerenxinxi">
    <div>
      <div class="demo-left" style="overflow-x: none">
        <div
          class="step-box animated fadeInUp"
          style="display: flex; flex-direction: column"
        >
          <div>
            <div class="my-title">人才库信息登记表</div>
            <div class="my-subtitle"></div>
          </div>
          <table class="table" cellspacing="0" cellpading="0" border="0">
            <tr>
              <td style="width: 120px">
                <font style="color: red">*</font>姓名
              </td>
              <td>
                {{ signupInfo.name }}
              </td>
              <td style="width: 120px">
                <font style="color: red">*</font>性别
              </td>
              <td>
                {{ signupInfo.gender == 1 ? "男" : "女" }}
              </td>
              <!-- <td style="width: 60px !important">
                  <font style="color: red">*</font>出生年月
                </td>
                <td style="width: 205px !important">
                  {{ signupInfo.birthday }}
                </td> -->
              <td rowspan="4" style="width: 139px; height: 139px">
                <img :src="signupInfo.headUrl" width="130px" height="160px" />
              </td>
            </tr>
            <tr>
              <td><font style="color: red">*</font>联系电话</td>
              <td style="width: 160px !important">
                {{ signupInfo.telephone }}
              </td>

              <td><font style="color: red">*</font>身份证号</td>
              <td>
                {{ signupInfo.cardNum }}
              </td>
            </tr>
            <tr>
              <td style="width: 120px">
                <font style="color: red">*</font>民族
              </td>
              <td>
                <select id="nation" name="nation" v-model="signupInfo.nation">
                  <option selected disabled hidden value=""></option>
                  <option
                    v-for="(item, index) in nations"
                    :key="index"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </td>

              <td><font style="color: red">*</font>电子邮箱</td>
              <td>
                {{ signupInfo.email }}
              </td>
            </tr>
            <tr>
              <td><font style="color: red">*</font>政治面貌</td>
              <td>
                <select
                  id="political"
                  name="political"
                  v-model="signupInfo.political"
                >
                  <option selected disabled hidden value=""></option>
                  <option value="群众">群众</option>
                  <option value="共青团员">共青团员</option>
                  <option value="预备党员">预备党员</option>
                  <option value="中共党员">中共党员</option>
                  <option value="其他">其他</option>
                </select>
              </td>
              <td><font style="color: red">*</font>婚否</td>
              <td>
                <select v-model="signupInfo.isMarry">
                  <option selected disabled hidden value=""></option>
                  <option value="未婚">未婚</option>
                  <option value="已婚">已婚</option>
                  <option value="离异">离异</option>
                </select>
              </td>
              <!-- <td><font style="color: red">*</font>健康状况</td>
                <td>
                  <select v-model="signupInfo.health">
                    <option selected disabled hidden value=""></option>
                    <option value="健康">健康</option>
                    <option value="良好">良好</option>
                    <option value="其他">其他</option>
                  </select>
                </td> -->
            </tr>
            <tr>
              <td><font style="color: red">*</font>出生地</td>
              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="signupInfo.birthAddress"
                  placement="top"
                >
                  <input
                    style="width: 160px !important"
                    type="text"
                    v-model="signupInfo.birthAddress"
                  />
                </el-tooltip>
              </td>
              <td><font style="color: red">*</font>户籍地</td>
              <td colspan="2">
                <el-cascader
                  class="form-input-native-place"
                  placeholder="请选择籍贯"
                  :options="nativePlaceOptions"
                  :props="treeSelect"
                  filterable
                  clearable
                  v-model="signupInfo.nativePlaceInfo"
                  ref="cascader_Ref"
                />
                <el-input
                  style="width: 130px !important"
                  v-model="signupInfo.nativeAddress"
                  placeholder="详细地址"
                />
              </td>
            </tr>
            <tr>
              <td><font style="color: red">*</font>健康状况</td>
              <td>
                <select v-model="signupInfo.health">
                  <option selected disabled hidden value=""></option>
                  <option value="健康">健康</option>
                  <option value="良好">良好</option>
                  <option value="其他">其他</option>
                </select>
              </td>
              <td><font style="color: red">*</font>现住址</td>
              <td colspan="2">
                <el-cascader
                  class="form-input-native-place"
                  placeholder="请选择现住址"
                  :options="presentAddressOptions"
                  :props="treeSelect"
                  filterable
                  clearable
                  v-model="signupInfo.currentInfo"
                />
                <el-input
                  style="width: 130px !important"
                  v-model="signupInfo.currentAddress"
                  placeholder="详细地址"
                />
              </td>
            </tr>
            <tr>
              <!-- -->
              <td colspan="5" style="padding: 0px">
                <table
                  style="width: 100%"
                  class="innertable"
                  cellspacing="0"
                  cellpading="0"
                  id="family"
                >
                  <tr>
                    <td class="tdcenter" style="width: 120px">参加工作时间</td>
                    <td>
                      <el-date-picker
                        style="width: 138px !important"
                        v-model="signupInfo.workTime"
                        type="date"
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </td>
                    <td>现工作单位</td>
                    <td>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="signupInfo.workCompany"
                        placement="top"
                      >
                        <input type="text" v-model="signupInfo.workCompany" />
                      </el-tooltip>
                    </td>
                    <td>现工作部门及岗位</td>
                    <td>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="signupInfo.workDeptPost"
                        placement="top"
                      >
                        <input type="text" v-model="signupInfo.workDeptPost" />
                      </el-tooltip>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td>教育经历(按时间先后顺序填写)</td>
              <td colspan="5" style="padding: 0px">
                <table
                  style="width: 100%"
                  class="innertable"
                  cellspacing="0"
                  cellpading="0"
                  id="family"
                >
                  <tr>
                    <td
                      align="center"
                      style="border-left: none; border-top: none; width: 210px"
                    >
                      起止时间
                    </td>
                    <td align="center" style="border-top: none">学校名称</td>
                    <td align="center" style="border-top: none">专 业</td>
                    <td align="center" style="border-top: none; width: 140px">
                      学历
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in educationExperienceList"
                    :key="index"
                  >
                    <td align="center">
                      <el-date-picker
                        style="width: 210px"
                        @change="workTimeChange($event, item)"
                        v-model="item.startEndTime"
                        type="daterange"
                        range-separator="-"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        unlink-panels
                      >
                      </el-date-picker>
                    </td>
                    <td align="center">
                      <input type="text" v-model="item.college" />
                    </td>
                    <td align="center">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.major"
                        placement="top"
                      >
                        <input type="text" v-model="item.major" />
                      </el-tooltip>
                    </td>
                    <td align="center">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <el-select
                          style="width: 120px"
                          clearable
                          v-model="item.degree"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="(item, index) in degreeList"
                            :key="index"
                            :label="item.name"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>

                        <span
                          v-if="item.id.length > 1"
                          @click="delrowEdu(item)"
                          style="
                            justify-content: center;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            color: red;
                          "
                          >移除</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="border-right: none">
                      <span
                        class="rowBtn"
                        @click="addrowEdu()"
                        style="
                          justify-content: center;
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                        "
                        >加一行</span
                      >
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td>工作经历(按时间先后顺序填写)</td>
              <td colspan="5" style="padding: 0px">
                <table
                  style="width: 100%"
                  class="innertable"
                  cellspacing="0"
                  cellpading="0"
                  id="family"
                >
                  <tr>
                    <td
                      align="center"
                      style="border-left: none; border-top: none; width: 210px"
                    >
                      起止时间
                    </td>
                    <td align="center" style="border-top: none">单位及部门</td>
                    <td align="center" style="border-top: none">岗位及职务</td>
                    <td align="center" style="border-top: none">
                      主要工作职责
                    </td>
                  </tr>

                  <tr v-for="(item, index) in workExperienceList" :key="index">
                    <td align="center">
                      <el-date-picker
                        style="width: 210px"
                        @change="workTimeChange($event, item)"
                        v-model="item.startEndTime"
                        type="daterange"
                        range-separator="-"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        unlink-panels
                      >
                      </el-date-picker>
                    </td>
                    <td align="center">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.unitDept"
                        placement="top"
                      >
                        <input type="text" v-model="item.unitDept" />
                      </el-tooltip>
                    </td>
                    <td align="center">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.post"
                        placement="top"
                      >
                        <input type="text" v-model="item.post" />
                      </el-tooltip>
                    </td>
                    <td align="center">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item.duty"
                          placement="top"
                        >
                          <input type="text" v-model="item.duty" />
                        </el-tooltip>

                        <span
                          v-if="item.id.length > 1"
                          @click="delrow(item)"
                          style="
                            justify-content: center;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            color: red;
                          "
                          >移除</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="border-right: none">
                      <span
                        class="rowBtn"
                        @click="addrow()"
                        style="
                          justify-content: center;
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                        "
                        >加一行</span
                      >
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="tdcenter">获得奖励<br />情况</td>
              <td colspan="5">
                <textarea rows="2" v-model="signupInfo.rewards"></textarea>
              </td>
            </tr>
            <tr>
              <td>相关资格证书（专业技术资格、职（执）业资格等）</td>
              <td colspan="5" style="padding: 0px">
                <table
                  style="width: 100%"
                  class="innertable"
                  cellspacing="0"
                  cellpading="0"
                  id="family"
                >
                  <tr>
                    <td
                      align="center"
                      style="border-left: none; border-top: none"
                    >
                      名称
                    </td>
                    <td align="center" style="border-top: none">等级</td>
                    <td align="center" style="border-top: none">获得时间</td>
                    <td align="center" style="border-top: none">颁发机构</td>
                  </tr>
                  <tr v-for="(item, index) in certificateList" :key="index">
                    <td>
                      <input type="text" v-model="item.name" />
                    </td>
                    <td>
                      <input type="text" v-model="item.grade" />
                    </td>
                    <td>
                      <input type="text" v-model="item.getTime" />
                    </td>
                    <td>
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <input type="text" v-model="item.organization" />
                        <span
                          v-if="item.id.length > 1"
                          @click="delrowCert(item)"
                          style="
                            justify-content: center;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            color: red;
                          "
                          >移除</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="border-right: none" colspan="5">
                      <span
                        class="rowBtn"
                        @click="addrowCert()"
                        style="
                          justify-content: center;
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                        "
                        >加一行</span
                      >
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="tdcenter">其他需说明的情况</td>
              <td colspan="5">
                <textarea rows="2" v-model="signupInfo.remark"></textarea>
              </td>
            </tr>
            <tr>
              <td><font style="color: red">*</font>求职意向</td>
              <td>
                <select v-model="signupInfo.status">
                  <option value="0">否</option>
                  <option value="1">是</option>
                </select>
              </td>
              <td><font style="color: red">*</font>意向岗位</td>
              <td colspan="2">
                <input type="text" style="width: 200px !important;" v-model="signupInfo.desiredPost" />
                
              </td>
            </tr>
          </table>
          <div class="mybtns" id="step2BtnTwo" style="position: unset">
            <button
              class="step3 default-btn next-btn"
              style="width: 120px; height: 38px; line-height: 30px"
              @click="addOrUpdate"
            >
              {{ !signupInfo.id ? "提交" : "更新" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import axios from "axios";
import request from "@/request";

export default {
  name: "SignUp",
  props: {
    recruitId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      studentInfo: {
        cardType: "",
        headUrl: "",
      },
      uploadImgUrl: request.uploadFile,
      headers: {
        Authorization: this.$cookies.get(this.$commons.User.Authentication),
      },
      fileType: ["png", "jpg", "jpeg"],
      showSignUp: false,
      userInfo: {},

      educationExperienceList: [
        {
          id: 1,
          startEndTime: "",
          startTime: null,
          endTime: null,
          college: "",
          major: "",
          degree: "",
        },
        {
          id: 2,
          startEndTime: "",
          startTime: null,
          endTime: null,
          college: "",
          major: "",
          degree: "",
        },
      ],
      workExperienceList: [
        {
          id: 1,
          startEndTime: "",
          startTime: null,
          endTime: null,
          unitDept: "",
          post: "",
          duty: "",
        },
        {
          id: 2,
          startEndTime: "",
          startTime: null,
          endTime: null,
          unitDept: "",
          post: "",
          duty: "",
        },
      ],
      certificateList: [
        { id: 1, name: "", grade: "", getTime: "", organization: "" },
        { id: 2, name: "", grade: "", getTime: "", organization: "" },
      ],
      nations: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],
      degreeList: [
        { name: "高中以下", value: 1 },
        { name: "高中/中专", value: 2 },
        { name: "大专", value: 3 },
        { name: "本科", value: 4 },
        { name: "研究生", value: 5 },
        { name: "博士", value: 6 },
      ],

      signupInfo: {
        status: 0,
      },
      post: {
        noticeId: "",
      },

      nativePlaceOptions: [],
      presentAddressOptions: [],
      treeSelect: {
        label: "areaName",
        value: "areaName",
        level: "level",
      },
      schoolFeatureList: [],
    };
  },
  activated() {
    let _this = this;
    // _this.getUserInfo();
    _this.getSysArea();
    _this.getMinePool();
  },
  mounted() {
    let _this = this;
  },
  methods: {
    getMinePool() {
      let _this = this;
      _this.$api.pool.getByUser().then((res) => {
        console.log('res',res)
        if (res.data) {
          _this.signupInfo = res.data;
          if (_this.signupInfo.workExperience) {
            _this.workExperienceList = JSON.parse(
              _this.signupInfo.workExperience
            );
          }
          if (_this.signupInfo.certificate) {
            _this.certificateList = JSON.parse(_this.signupInfo.certificate);
          }
          if (_this.signupInfo.educationExperience) {
            _this.educationExperienceList = JSON.parse(
              _this.signupInfo.educationExperience
            );
          }

          if (_this.signupInfo.current) {
            _this.signupInfo.currentInfo = _this.signupInfo.current.split(",");
          }
          if (_this.signupInfo.nativePlace) {
            _this.signupInfo.nativePlaceInfo =
              _this.signupInfo.nativePlace.split(",");
          }
        } else {
          _this.getUserInfo();
        }
      });
    },
    getUserInfo() {
      let _this = this;
      _this.$api.employee
        .getUserInfo()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.signupInfo.name = res.data.name;
            _this.signupInfo.gender = res.data.gender;
            _this.signupInfo.birthday = res.data.birthday;
            _this.signupInfo.telephone = res.data.telephone;
            _this.signupInfo.email = res.data.email;
            _this.signupInfo.cardNum = res.data.cardNum;
            _this.signupInfo.headUrl = res.data.headUrl;
            _this.$forceUpdate();
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    addOrUpdate() {
      let _this = this;
      _this.signupInfo.workExperience = JSON.stringify(
        _this.workExperienceList
      );
      _this.signupInfo.certificate = JSON.stringify(_this.certificateList);
      _this.signupInfo.educationExperience = JSON.stringify(
        _this.educationExperienceList
      );
      _this.signupInfo.current = _this.signupInfo.currentInfo?_this.signupInfo.currentInfo.join(","):'';
      _this.signupInfo.nativePlace = _this.signupInfo.nativePlaceInfo?_this.signupInfo.nativePlaceInfo.join(","):'';
      if (!_this.signupInfo.id) {
        _this.$api.pool.addPoolInfo(_this.signupInfo).then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.$layer.alert("提交成功");
          }
        });
      } else {
        _this.$api.pool.updatePoolInfo(_this.signupInfo).then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.$layer.alert("更新成功");
          }
        });
      }
      _this.getMinePool();
    },
    // 查询 中国地区
    getSysArea() {
      let _this = this;
      _this.$api.sign.getSysAreaList().then((res) => {
        // 籍贯
        _this.nativePlaceOptions = res.data;
        // 现住址
        _this.presentAddressOptions = res.data;
      });
    },
    addrow() {
      let _this = this;
      _this.workExperienceList.push({
        id: _this.$util.uuid(),
        startEndTime: "",
        startTime: null,
        endTime: null,
        uintDept: "",
        post: "",
        duty: "",
      });
    },
    addrowCert() {
      let _this = this;
      _this.certificateList.push({
        id: _this.$util.uuid(),
        name: "",
        grade: "",
        getTime: "",
        organization: "",
      });
    },
    addrowEdu() {
      let _this = this;
      _this.educationExperienceList.push({
        id: _this.$util.uuid(),
        startEndTime: "",
        startTime: null,
        endTime: null,
        college: "",
        major: "",
        degree: "",
      });
    },
    delrow(row) {
      let _this = this;
      _this.workExperienceList = _this.workExperienceList.filter(
        (item) => item.id != row.id
      );
    },
    delrowCert(row) {
      let _this = this;
      _this.certificateList = _this.certificateList.filter(
        (item) => item.id != row.id
      );
    },
    delrowEdu(row) {
      let _this = this;
      _this.educationExperienceList = _this.educationExperienceList.filter(
        (item) => item.id != row.id
      );
    },
    workTimeChange(e, item) {
      if (e) {
        item.startTime = e[0];
        item.endTime = e[1];
      }
    },
  },
};
</script>

<style scoped>
select {
  width: 100px;
  background: #fff;
  border: 1px solid #ededed;
  padding: 2px 0 2px 5px;
  border-radius: 4px;
}
.header-right {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background: #909399;
  color: #fff;
  right: 5px;
  top: 5px;
  text-align: center;
  cursor: pointer;
}
.header {
  height: 40px;
}
.tankuang {
  position: relative;
  background: #fff;
  border-radius: 5px;
  margin: auto;
}
input.error {
  border: 1px solid red !important;
}
label.error {
  font-size: 12px;
  color: #ea5200;
}
.rowBtn {
  width: 88px !important;
  height: 34px;
  background: none;
  border: 1px #ccc solid;
  color: #333;
  margin-left: 10px;
}
.table {
  width: 100%;
  border-top: 1px #ddd solid;
  border-left: 1px #ddd solid;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 4px;
}
.table tr td {
  border-right: 1px #ddd solid;
  border-bottom: 1px #ddd solid;
  padding: 4px 15px;
  height: 40px;
}
.table input {
  height: 30px;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
  width: 100px;
}
.innertable input {
  width: 100px;
}
.table textarea {
  width: 100%;
  height: 100px;
  flex: 1;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
}
.tdcenter {
  text-align: center;
}
.upload_table >>> ::v-deep .el-upload__input {
  display: none !important;
}
.upload_table >>> ::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader >>> .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-cascader {
  width: 200px;
}
.my-title-box {
  margin: 12px 0;
}
.my-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.mybtns {
  margin-top: 16px;
  text-align: center;
}
.default-btn {
  padding: 6px 16px;
  margin: 0 8px;
}
</style>

<style>
.required:before {
  content: "* ";
  color: red;
}

.cropImgContent {
  width: 480px;
  float: left;
}

.cropImgContent img {
  box-shadow: 0 0 5px #adadad;
}

.previewContent {
  float: left;
  margin-left: 52px;
}

.previewContent .previewText {
  font-size: 16px;
  margin-top: 16px;
  text-align: center;
}

.previewContent .previewBox,
.previewContent .previewBoxRound {
  box-shadow: 0 0 5px #adadad;
  width: 100px;
  height: 100px;
  margin-top: 20px;
  overflow: hidden;
}

.previewContent .previewBoxRound {
  border-radius: 50%;
  margin-top: 40px;
}

body .custom-layer .layui-layer-title {
  background: #be1a21;
  color: #fff;
  border: none;
}

body .custom-layer .layui-layer-btn {
  border-top: 1px solid #e9e7e7;
}

body .custom-layer .layui-layer-btn a {
  background: #be1a21;
  border-color: #be1a21;
}

body .custom-layer .layui-layer-btn .layui-layer-btn1 {
  background: #be1a21;
}

select {
  width: 300px;
  background: #f8f8f8;
  border: 1px solid #ededed;
  padding: 8px 0 8px 10px;
  border-radius: 4px;
}

.el-upload__input {
  display: none !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.rczp-row textarea {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  width: 100%;
  padding: 11px 0 5px 12px;
  margin-top: 10px;
  resize: none;
  outline: none;
  border: none;
  border-bottom: 1px solid #ededed;
}
.rczp-row-file {
  display: flex;
  height: auto;
}

.append_content {
  margin: 40px auto !important;
  width: 890px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.appendList {
  display: flex;
  flex-flow: column;
  margin-right: 20px;
  margin-bottom: 20px;
  width: 270px;
  height: 206px;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px rgb(208 208 208 / 50%);
  border-radius: 10px;
  transition: all 0.2s;
  padding-top: 10px;
}

.appendList:hover {
  cursor: pointer;
  box-shadow: 10px 6px 40px rgb(208 208 208);
}

.append_image {
  height: 128px;
  width: 250px;
  margin: auto;
}

.append_image img {
  height: 100%;
  max-width: 100%;
}

.append_name {
  height: 30px;
  width: 250px;
  margin: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.2s;
}

.append_btn {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  align-content: center;
  padding: 5px;
}

.appendList:hover .append_name {
  color: #409eff !important;
  transform: scale(1.02);
  font-weight: 600;
}

.showEdit {
  opacity: 1 !important;
}

.el-date-editor .el-range__close-icon {
  width: 0px !important;
}
.el-select-dense >>> input {
  height: 35px;
}
.el-select-dense >>> .el-input__icon {
  line-height: 35px;
}
.demo-left {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/mine/minePool.vue